import { Component, OnInit } from "@angular/core";

@Component({
  templateUrl: "./all-posts.component.html",
})
export class AllPostsComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
